import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=77ff3834&scoped=true"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"
import style0 from "./brandList.vue?vue&type=style&index=0&id=77ff3834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff3834",
  null
  
)

export default component.exports